export default function getHostname(url: string | null) {
  if (!url) {
    return null;
  }

  return url.replace("http://", "").replace("https://", "").replace("www.", "").split(/[/?#]/)[0];
}
